/**
 * DIV-046 (issue #381): the shared terminal-failure path for `/cart/add` and
 * the post-add cart-confirmation poll — hide the loader, reset the in-flight
 * flag and show a translated message in `#errDialog` without navigating
 * anywhere. Mirrors the dialog sequence `stock-limit.ts` already uses for a
 * new-flow stock-limited add (DIV-044), kept separate so this fix cannot
 * perturb that pinned behavior.
 */
import $ from "jquery";
import { appState } from "../state/app-state";
import { t } from "../i18n/translate";
import { withDialog } from "../compat/jquery-ui-dialog";

export const ADD_TO_CART_FAILED_MESSAGE =
  "Sorry, we couldn't add this to your cart. Please try again.";

// cart-ready.ts's poll runs only after /cart/add already succeeded — the
// item IS in the cart, so its terminal paths must not claim otherwise (same
// "don't assert a negative you can't back up" rule as stock-limit.ts's
// CHECK_CART_MESSAGE).
export const CART_CONFIRMATION_FAILED_MESSAGE =
  "We've added this to your cart, but couldn't confirm your price. Please check your cart before checking out.";

export function showAddToCartError(message: string): void {
  $(".loading-anim-cpc").hide();
  $("#errDialog").attr("title", "Error");
  $("#dialogMsg").text(t(message));
  withDialog(() => ($("#errDialog") as any).dialog({ modal: true }));
  appState.cpc_isCheckoutInProgress = false;
}
